import _defineProperty from "/app/node_modules/babel-runtime/helpers/defineProperty";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListItem from "~/components/collaborators/slide-item";
import newSellerModal from "~/components/collaborators/new-seller-modal";
import editChannelModal from "~/components/collaborators/edit-channel";
import alertModal from "~/components/collaborators/alert-modal";
import newTeamModal from "~/components/collaborators/new-team-modal";
import loader from "~/components/modals/loader";
import { mapState, mapActions } from "vuex";

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            store.commit("dashboard/details/setToolbarTitle", "Colaboradores");
                            _context.prev = 1;
                            _context.next = 4;
                            return _Promise.all([store.dispatch("user/showListByRol")]);

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context["catch"](1);

                            app.$controlMessage(_context.t0);

                        case 9:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 6]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    asyncData: function asyncData(_ref3) {
        var app = _ref3.app,
            redirect = _ref3.redirect;

        if (app.$isAdmin()) {
            return redirect("/bosses");
        } else if (app.$isSupervisor()) {
            return redirect("/my-team");
        }
        return null;
    },

    components: {
        ListItem: ListItem,
        editChannelModal: editChannelModal,
        alertModal: alertModal,
        newSellerModal: newSellerModal,
        newTeamModal: newTeamModal,
        loader: loader
    },
    data: function data() {
        return {
            buttonAddColaborator: false,
            collaboratorsTitle: "",
            typeOfTable: "",
            conditionalNotContent: false,
            messageNotContent: "No hay contenido",
            isDetailSeller: false,
            loaderText: "Procesando información"
        };
    },

    computed: _extends({}, mapState({
        listOfChannel: function listOfChannel(state) {
            return state.channel.items;
        }
    })),
    methods: (_methods = {
        openNewItem: function openNewItem() {
            this.$refs.newSellerModal.addNewSeller();
        },
        completeForm: function completeForm() {
            this.$refs.alertModal.openModal();
            this.closeShowChannel();
        },
        showChannels: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.updateShowChannels(value);

                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function showChannels(_x2) {
                return _ref4.apply(this, arguments);
            }

            return showChannels;
        }(),
        upDateListBoss: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$store.dispatch("user/showListByRol");

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function upDateListBoss() {
                return _ref5.apply(this, arguments);
            }

            return upDateListBoss;
        }(),
        setDefaultToBoss: function setDefaultToBoss() {
            this.type = "Equipo 1";
            this.typeState = "Equipo Activo";
            this.collaboratorsTitle = "Canales";
            this.buttonNewCollaborator = "Nuevo Vendedor";
            this.typeOfTable = "Teams";
        },
        updateShowChannels: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value) {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(this.collaboratorsTitle === "Canales")) {
                                    _context4.next = 5;
                                    break;
                                }

                                _context4.next = 3;
                                return this.$store.dispatch("channel/loadTeams", value);

                            case 3:
                                _context4.next = 6;
                                break;

                            case 5:
                                return _context4.abrupt("return");

                            case 6:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function updateShowChannels(_x3) {
                return _ref6.apply(this, arguments);
            }

            return updateShowChannels;
        }(),
        addNewItem: function addNewItem(val) {
            this.$refs.newTeamModal.channelIsActive = val.active;
            this.$refs.newTeamModal.value = val.value;
            this.$refs.newTeamModal.addModalConfig();
        },
        editThisChannel: function editThisChannel(value) {
            this.$refs.editChannelModal.idChannel = value;
            this.$refs.editChannelModal.editThisChannel();
        }
    }, _defineProperty(_methods, "upDateListBoss", function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return this.$store.dispatch("user/showListByRol");

                        case 2:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function upDateListBoss() {
            return _ref7.apply(this, arguments);
        }

        return upDateListBoss;
    }()), _defineProperty(_methods, "toDetailTable", function toDetailTable(val) {
        this.$refs.loaderModal.showLoader();
        this.$router.push({
            path: "/channels/teams/" + val.val.item.value,
            query: { channelStatus: val.val.teamIsActive }
        });
    }), _defineProperty(_methods, "closeShowChannel", function closeShowChannel() {
        var _this = this;

        if (this.listOfChannel) {
            this.listOfChannel.forEach(function (item, i) {
                _this.$refs.listItem[i].showTable = false;
            });
        }
    }), _methods),
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.multipleOptions = true;
            _this2.setDefaultToBoss();
            //Si no hay contenido
            if (_this2.listOfChannel.length == 0) {
                _this2.conditionalNotContent = true;
                _this2.messageNotContent = "No hay Canales asignados a este Jefe";
            } else {
                _this2.conditionalNotContent = false;
            }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/channels/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/channels/index.vue
// module chunks = 6